import { FiArrowUpRight, FiFileText } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export const OpenRoles = () => {
  const ENGINEER_APPLICATION_FORM = 'https://forms.gle/Husak3ciXQfNdNzn7'
  const BUSINESS_TEAM_APPLICATION_FORM = 'https://forms.gle/zUAeEEWMYD1hdrZX6'
  const APPLICATIONS_OPEN = true;
  const navigate = useNavigate();
  const openRoles = [
    // Business team — SFURS_Hiring_Package.pdf (2026)
    {
      name: "VP Operations",
      description: "",
      linkApply: BUSINESS_TEAM_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/join",
    },
    {
      name: "VP Marketing",
      description: "",
      linkApply: BUSINESS_TEAM_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/join",
    },
    // Technical team
    {
      name: "Mechanics Co-Lead",
      description: "",
      linkApply: ENGINEER_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/join",
    },
    {
      name: "Mechanics Engineer",
      description: "",
      linkApply: ENGINEER_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/join",
    },
    {
      name: "Electronics Engineer",
      description: "",
      linkApply: ENGINEER_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/join",
    },
    {
      name: "Firmware Developer",
      description: "",
      linkApply: ENGINEER_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/join",
    },
    {
      name: "Software Developer",
      description: "",
      linkApply: ENGINEER_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/join",
    },
  ];

  const visibleRoles = APPLICATIONS_OPEN ? openRoles : [];

  return (
    <div className="w-11/12 ml-auto mr-auto lg:w-full mt-10 lg:mt-32 flex items-center flex-col lg:flex-row justify-between">
      <div className="lg:w-full flex flex-col">
        <h2 className="plus-jakarta-sans-heading text-xl mb-2">Open Roles</h2>
        <h3 className="plus-jakarta-sans-body text-md text-black text-opacity-60 mb-3">
          {APPLICATIONS_OPEN ? (
            <>
              Are you interested in robotics and soccer? Do you want to be part of a
              winning team? Then come and join us at the Simon Fraser University
              Robot Soccer Club! We are always looking for new members to join our
              software, electronics, firmware, and mechanics teams. If you are
              interested in joining one of these teams then apply now!
            </>
          ) : (
            <>
              Thanks for your interest in SFU Robot Soccer! We are not accepting
              applications right now. Check back later or follow us on social media
              for updates.
            </>
          )}
        </h3>
        <div className="flex gap-10 mt-2 lg:mt-10 lg:mt-0 lg:gap-10 flex-col">
          <div className="flex flex-wrap gap-x-4 gap-y-4">
            {visibleRoles.length !== 0 ? (
              visibleRoles.map((role, index) => (
                <button
                  key={index}
                  onClick={() => navigate(`${role.goTo}`)}
                  className="flex bg-black bg-opacity-5 text-start lg:hover:cursor-pointer lg:hover:bg-red-100 transition duration-300 ease-in-out px-8 py-6 rounded-lg flex-col gap-4"
                >
                  <div className="flex flex-col lg:w-10/12">
                    <h2 className="plus-jakarta-sans-button text-xl">
                      {role.name}
                    </h2>
                  </div>
                  {/* <button
                      id="buttonPrimary"
                      onClick={() => window.open(role.linkApply, "_blank")}
                      className="flex w-max items-center gap-2 plus-jakarta-sans-button text-sm px-6 py-2 tracking-wide rounded-md"
                    >
                      Apply Now
                    </button> */}
                </button>
              ))
            ) : (
              <h2 className="plus-jakarta-sans-body text-black text-lg leading-6">
                {APPLICATIONS_OPEN
                  ? "There are currently no open roles at SFU RS."
                  : "Applications are currently closed."}
              </h2>
            )}
          </div>
          {/* {openRoles.length !== 0 && (
            <div className="flex flex-row gap-2 -mt-2">
              <a
                href={
                  "https://docs.google.com/forms/d/e/1FAIpQLScQbtJXuMKvOpBZ-aJ8k2db6INAc6iK9aw7l8RwxHJWlTonEQ/viewform"
                }
                target="_blank"
              >
                <button
                  id="buttonPrimary"
                  className="flex w-max items-center gap-2 plus-jakarta-sans-button text-sm px-6 py-2 tracking-wide rounded-md"
                >
                  Apply Now
                </button>
              </a>
              <a href={"/join"}>
                <button
                  id="buttonSecondary"
                  className="flex w-max items-center gap-2 plus-jakarta-sans-button text-sm px-6 py-2 tracking-wide rounded-md"
                >
                  More Info
                  <FiArrowUpRight strokeWidth={3} />{" "}
                </button>
              </a>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};
